import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "@/Utils/firebase";
import { useScanData } from "./useScanData";

const getSharedClients = async (
  scanId: string,
  clientIds: string[] | undefined
) => {
  if (!clientIds) return [];
  if (clientIds.length === 0) return [];
  const clientsQuery = query(
    collection(db, "clientIds"),
    where("clientId", "in", clientIds)
  );
  const clients = await getDocs(clientsQuery);
  return clients.docs.map((client) => client.data());
};

export const useShareHistory = (scanId: string) => {
  const { data: scanData } = useScanData(scanId);
  const queryResult = useQuery({
    queryKey: ["shareHistory", scanId],
    queryFn: () => getSharedClients(scanId, scanData?.clientIds),
  });
  useEffect(() => {
    if (scanData?.clientIds) {
      queryResult.refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scanData?.clientIds]);
  return queryResult;
};
